import { render, staticRenderFns } from "./viewComponent.vue?vue&type=template&id=ef561682&scoped=true&"
import script from "./viewComponent.vue?vue&type=script&lang=js&"
export * from "./viewComponent.vue?vue&type=script&lang=js&"
import style0 from "./viewComponent.vue?vue&type=style&index=0&id=ef561682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef561682",
  null
  
)

export default component.exports